import {HOMEPAGE_TEMPLATE_KEY} from "../../utils/constants";
import {isTemplateEnabled} from "./isTemplateEnabled";

export function isNewsfeedTemplateLayout(appStyles) {
  const newsfeedTemplateIsSelected = isTemplateEnabled(appStyles, HOMEPAGE_TEMPLATE_KEY.newsfeed);
  const pointsTemplateIsSelected = isTemplateEnabled(appStyles, HOMEPAGE_TEMPLATE_KEY.loyalty);
  return newsfeedTemplateIsSelected || pointsTemplateIsSelected;
}
